/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled';

import { SentryErrorBoundary } from '../../../../common/sentry';
import { Footer } from '../../../components/Footer';
import { CollaborationTop5Section } from '../../../components/Sections/CollaborationTop5Section';
import { ConnectorShowcaseSection } from '../../../components/Sections/ConnectorShowcaseSection';
import { ConnectorsSection } from '../../../components/Sections/ConnectorsSection';
import { ExploreGraphSection } from '../../../components/Sections/ExploreGraphSection';
import { GettingStartedSection } from '../../../components/Sections/GettingStartedSection';

import { messages } from './messages';
import { OrgMetricsSection } from './OrgMetricsSection';

const styles = cssMap({
	pageContainer: {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#111213',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		minHeight: '100vh',
		WebkitFontSmoothing: 'antialiased',
		MozOsxFontSmoothing: 'grayscale',
	},
});

export function LoggedInView(): JSX.Element {
	// `accountIdAtom`, `cloudIdAtom`, and `relayEnvironmentAtom` are
	// hydrated by the parent `LoggedInGate` (in `home/index.tsx`) once the
	// App Switcher `available-products` request resolves, so this view
	// can stay focussed purely on layout.
	//
	// Per-section reveal analytics are now emitted by each Section
	// component itself via `useSectionReveal`. This view is pure
	// composition — no analytics wrappers, no auth-state plumbing.
	return (
		<div css={styles.pageContainer}>
			<OrgMetricsSection />
			<SentryErrorBoundary
				// TODO: GRAPHYTE-2509 Error fallback / Suspense Fallback
				fallback={
					<div>
						<FormattedMessage {...messages.collaborationTop5ErrorFallback} />
					</div>
				}
				touchpointId="CollaborationTop5Section"
			>
				<CollaborationTop5Section />
			</SentryErrorBoundary>
			<SentryErrorBoundary
				fallback={
					<Box>
						<FormattedMessage {...messages.connectorsErrorFallback} />
					</Box>
				}
				touchpointId="ConnectorsSection"
			>
				<ConnectorsSection />
			</SentryErrorBoundary>
			<ExploreGraphSection />
			<GettingStartedSection />
			<ConnectorShowcaseSection />
			<Footer />
		</div>
	);
}
